<vwui-button icon="filter" (click)="overlayOpen = true">
  <span class="whitespace-nowrap block md:hidden">Filteren</span>
  <span class="whitespace-nowrap hidden md:block">Meer filters</span>
</vwui-button>
<div class="fixed inset-y-0 right-0 w-96 max-w-full bg-white shadow-filter z-10 transform transition flex flex-col"
  [formGroup]="form"
  [class.invisible]="!overlayOpen"
  [class.translate-x-full]="!overlayOpen">
  <div class="flex items-center mb-2 flex-none pt-8 px-8">
    <h2 class="font-medium text-xl m-0">Filters</h2>
    <vwui-btn-icon class="ml-auto" icon="vwui-close" (click)="overlayOpen = false"></vwui-btn-icon>
  </div>
  <vwui-button class="flex-none px-8" (click)="resetFilters()">Filters resetten</vwui-button>

  <div class="overflow-y-scroll px-8 pb-8 mt-4">
    @for (collection of facets; track collection) {
      <h2 class="font-medium text-lg -mx-8 my-0 px-8 pt-4 pb-2 sticky top-0 bg-white z-10 border-t border-b border-neutral-3">{{ collection.title }}</h2>
      @for (facet of collection.items; track facet; let isLast = $last) {
        @switch (facet.type) {
          @case ('SIMPLE') {
            <app-search-filter-group-simple
              class="block py-4 border-neutral-3"
              [class.border-b]="!isLast"
              [group]="$any(facet)"
              [formControlName]="facet.field"
            ></app-search-filter-group-simple>
          }
          @case ('RANGE') {
            <app-search-filter-group-range
              class="block py-4 border-neutral-3"
              [class.border-b]="!isLast"
              [group]="$any(facet)" [formControlName]="facet.field"
            ></app-search-filter-group-range>
          }
        }
      }
    }
  </div>

</div>
